<template>
  <a-layout-content v-if="renderComponent">
    <a-row :gutter="{ xs: 0, lg: 8 }">
      <a-col :xs="24" :lg="8">
        <a-card>
          <span class="m-text-title" slot="title">Filter</span>
          <div class="d-flex flex-column">
            <a-input-search v-model="search" placeholder="Pencarian ... " />
            <a-collapse activeKey="1" class="m-top">
              <a-collapse-panel key="1">
                <span slot="header">Cari Lebih Lengkap</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Tanggal Transaksi</label>
                  <a-range-picker v-model="transactionDt" :format="getDefaultDateFormat" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="periode">Periode</label>
                  <a-monthPicker v-model="periode" allowClear />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-card>
        <a-card class="margin-top" style="display:none">
          <!-- dipindah di monitoring alokasi -->
          <span class="m-text-title" slot="title">Generate Rekap Pekerjaan</span>
          <div class="m-form-item-wrapper">
            <label for="periode">Periode</label>
            <a-monthPicker v-model="periode_generate" allowClear @change="changeGeneratePeriode">
              <a-icon slot="suffixIcon" type="loading" v-if="disabledGenerate" />
            </a-monthPicker>
          </div>
          <a-tooltip placement="topLeft" title="Generate Rekap Alokasi Pekerjaan" arrow-point-at-center>
            <a-button class="w-full" icon="hourglass" type="primary" :loading="loadingGenerate"
              @click="handleGenerateRekap" :disabled="isLoading || disabledGenerate">
              Generate
            </a-button>
          </a-tooltip>
        </a-card>
        <a-card class="margin-top">
          <span class="m-text-title" slot="title">Download Rekap Alokasi Pekerjaan</span>
          <div class="m-form-item-wrapper">
            <label for="periode">Periode</label>
            <a-range-picker
              :placeholder="['Start month', 'End month']"
              format="YYYY-MM"
              :value="periode_generate_excel"
              :mode="['month', 'month']"
              @panelChange="handleChange"
              @change="handlePanelChange"
              :allowClear="false"
              showTime
              class="w-full"
            />
            <!-- <a-monthPicker v-model="periode_generate_excel" allowClear>
              -- <a-icon slot="suffixIcon" type="loading" v-if="loadingGenerateExcel" /> --
            </a-monthPicker> -->
          </div>
          <div>
            <div class="contentX m-bottom" style="display:none">
              <a-table bordered :rowKey="(record, index) => { return index.toString(); }" :columns="downloadExcelData.column"
                :data-source="downloadExcelData.data" :scroll="{ y: 250 }" :pagination="false" size="small">
                <template slot="no" slot-scope="record, item, index">
                  <span>{{ index + 1 }}</span>
                </template>
                <template slot="periode" slot-scope="item">
                  <span>{{ moment(item.akhir_periode,'YYYY-MM-DD').format('MM-YYYY') }}</span>
                </template>
                <template slot="email" slot-scope="record">
                  <span>{{ record.email }}</span>
                </template>
              </a-table>
            </div>
          </div>
          <a-button class="w-full" icon="download" type="primary"
            @click="handleGenerateRekapExcel" :disabled="isLoading" :loading="loadingGenerateExcel">
            Download Rekap Excel
          </a-button>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="16">
        <H-Datalist title="Rekap Monitoring Alokasi Pekerjaan" :createLink="enableCreate ? 'create.alokasi' : ''"
          :manifestLink="manifestFor" :dataList="basedData" :isSpecialMenu="true" :isLoading="isLoading"
          :readable="true" />
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import DataList from "@/components/Datalist";
import moment from "moment";
import _ from "lodash";

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
    "H-Datalist": DataList,
  },
  data() {
    return {
      transactionDt: [],
      search: "",
      dataList: [],
      basedList: [],
      specialNav: [],
      isLoading: false,
      renderComponent: true,
      periode: null,
      enableCreate: false,
      loadingGenerate: false,
      loadingGenerateExcel: false,
      disabledGenerate: false,
      notyetAlokasi: [],
      periode_generate: moment(),
      periode_generate_excel: [moment().add(-1, 'months'),moment()],
      downloadExcelData: {
        data:[],
        column:[
          {
            title: "NO.",
            key: "no",
            width: 45,
            align: "right",
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Periode",
            key: "periode",
            width: 55,
            align: "center",
            scopedSlots: { customRender: "periode" },
          },
          {
            title: "TLC",
            key: "tlc",
            width: 55,
            align: "center",
            dataIndex: "tlc",
          },
          {
            title: "Nama",
            key: "nama",
            dataIndex: "nama",
          },
          {
            title: "Proyek",
            key: "c_proyek",
            width: 55,
            dataIndex: "c_proyek"
          },
          {
            title: "Persentase (%)",
            key: "persentase",
            width: 55,
            dataIndex: "persentase",
          },
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    basedData() {
      let output = [];

      if(this.searching.data){
        this.searching.data.forEach(data => {
          output.push({
            title: data.no_rekap,
            subdesc: [
              this.moment(data.awal_periode).format(this.getDefaultDateFormat) +
              " - " +
              this.moment(data.akhir_periode).format(this.getDefaultDateFormat),
              "HRD | Staff",
              "Surabaya",
              // data.departemen + " | " + data.posisi,
              // data.site
            ],
            id: data.id_rekap,
          });
        });
      }

      return output;
    },
    searching() {
      let data = this.dataList;

      if (this.search) {
        data = _.filter(
          data,
          (obj) =>
            obj.no_alokasi.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.akhir_periode
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.awal_periode.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.departemen.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.posisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.site.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.transactionDt.length > 0) {
        let startDt = moment(this.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(this.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        data = _.filter(
          data,
          (obj) => obj.awal_periode >= startDt && obj.akhir_periode <= endDt
        );
      }

      if (this.periode) {
        let periode = moment(this.periode).format("MMM YYYY").toLowerCase();

        data = _.filter(
          data,
          (obj) => obj.periode.toLowerCase().indexOf(periode) >= 0
        );
      }

      return data;
    },
    manifestFor() {
      // let manifest = "";
      // if (this.spesialFor === "Direktur") {
      //   manifest = "dir.mon.manifest.alokasi";
      // } else if (this.spesialFor === "Atasan Langsung") {
      //   manifest = "al.mon.manifest.alokasi";
      // } else if (this.spesialFor === "HRD") {
      //   manifest = "hrd.mon.manifest.alokasi";
      // }

      let manifest = "hrd.mon.manifest.ralokasi";

      return manifest;
    },
  },
  created() {
    //this.fetching();
  },
  methods: {
    moment,
    async fetching() {
      this.isLoading = true;
      const list = await axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/rekap_alokasi",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("mns_"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .catch((err) => {
        this.isLoading = false;
        return err;
      });

      const notyet = this.getConstGetnotYet()
      .catch((err) => {
          this.isLoading = false;
          return err;
        });

      Promise.all([list, notyet])
        .then((response) => {
          this.dataList = response[0].data;
          if (response[0].data.add == "1") {
            //this.enableCreate = true;
            this.enableCreate = false;
            localStorage.setItem("crtalks_", "1");
          } else {
            localStorage.setItem("crtalks_", "0");
          }

          this.notyetAlokasi = response[1].data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          return err;
        });
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
        this.fetching();
      });
    },
    async getConstGetnotYet() {
      const notyet = await axios({
        method: "get",
        url: this.$urlServiceNirmala + "get-karyawan-no-alokasi",
        params: {
          start_date: this.periode_generate ? moment(this.periode_generate).locale("en").subtract(1, 'months').format("YYYY-MM") + "-27" : undefined,
          end_date: this.periode_generate ? moment(this.periode_generate).locale("en").format("YYYY-MM") + "-28" : undefined,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
      return notyet
    },
    async changeGeneratePeriode() {
      const notyet = this.getConstGetnotYet()
      this.disabledGenerate = true
      Promise.all([notyet,])
        .then((response) => {
          this.notyetAlokasi = response[0].data;
          this.disabledGenerate = false
        })
        .catch(err => {
          this.disabledGenerate = false
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        })
    },
    handleGenerateRekap() {
      if (this.notyetAlokasi.length > 0) {
        this.displayMessageValue('info-basic', "Masih ada TLC yang belum melengkapi alokasi pekerjaan!\n\nLihat data tersebut pada monitoring alokasi pekerjaan");
      } else {
        this.loadingGenerate = true
        axios({
          method: "get",
          url: this.$urlServiceNirmala + "generate-rekap-alokasi",
          params: {
            start_date: this.periode_generate ? moment(this.periode_generate).locale("en").subtract(1, 'months').format("YYYY-MM") + "-27" : undefined,
            end_date: this.periode_generate ? moment(this.periode_generate).locale("en").format("YYYY-MM") + "-28" : undefined,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          }
        })
          .then(response => {
            this.loadingGenerate = false;
            this.displayMessageValue("success-basic", response.data.message);
            setTimeout(() => {
              this.$router.go();
            }, 1000);
          })
          .catch(err => {
            this.loadingGenerate = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          })
      }
    },
    handleChange(value){
      this.periode_generate_excel = value
    },
    handlePanelChange(value, mode) {
      this.periode_generate_excel = value;
      this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
    },
    handleGenerateRekapExcel(){
      if (this.periode_generate_excel==null) {
        this.displayMessageValue('info-basic', "Periode harus diisi!");
      } else {
        this.loadingGenerateExcel = true
        axios({
          method: "get",
          url: this.$serviceUrl + "rekap_alokasi/rekap_v2",
          params: {
            start_period: moment(this.periode_generate_excel[0]).format("YYYY-MM") + "-01",
            end_period: moment(this.periode_generate_excel[1]).format("YYYY-MM") + "-28"
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then(response => {
          this.downloadExcelData.data = response.data.data
          
          setTimeout(() => {
            const table = document.getElementsByClassName("contentX");
            const name = ''
            this.fireDownload(table, name);
            this.loadingGenerateExcel = false;
          }, 2000);
        })
        .catch(err => {
          this.loadingGenerateExcel = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        })
      }
    },
    fireDownload(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>table, td {border:thin solid black}table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };

      let periodExport = moment(this.periode_generate_excel[0])
      .locale("en")
        .format("MMM YYYY")
        .toUpperCase()
      +"_"+
      moment(this.periode_generate_excel[1])
        .locale("en")
        .format("MMM YYYY")
        .toUpperCase();

      if (!table.nodeType) table = document.getElementsByClassName("contentX");
      let ctx = { worksheet: name || "Worksheet", table: table[0].innerHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "Rekap Alokasi Pekerjaan " + periodExport + ".xls";
      a.click();
    },
  },
  mounted() {
    //this.fetching();
  },
  activated() {
    this.fetching();
  },
};
</script>

<style></style>
